export default "__VITE_ASSET__BTjfT1xY__"